const BULK_PAGE_SIZE = 500;

export async function fetchAllSearchPages<T>(
  searchPage: (filter: any) => Promise<{ items: T[]; total: number }>,
  where?: any,
  order?: string
): Promise<T[]> {
  const items: T[] = [];
  let skip = 0;
  let total = 0;

  do {
    const result = await searchPage({
      where: where || {},
      order: order || '_id ASC',
      skip,
      limit: BULK_PAGE_SIZE
    });
    const pageItems = Array.isArray(result.items) ? result.items : [];
    items.push(...pageItems);
    total = Number(result.total) || 0;
    skip += pageItems.length;

    if (pageItems.length === 0) break;
  } while (skip < total);

  return items;
}
